import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import { TransactionOverviewDetailsItem } from './TransactionOverviewDetailsItem'
import { ArrowRightIcon } from 'lucide-react'
import { useChainId } from 'wagmi'
import { getDisplayToken } from '@/domain/hooks/useDisplayToken'

interface TokenValueChangeProps {
  token: Token
  label: string
  currentValue: NormalizedUnitNumber
  updatedValue?: NormalizedUnitNumber
}

export function TokenValueChange({ token, label, currentValue, updatedValue }: TokenValueChangeProps) {
  if (updatedValue === undefined) {
    return (
      <TransactionOverviewDetailsItem label={label}>
        <TokenValue token={token} value={currentValue} />
      </TransactionOverviewDetailsItem>
    )
  }

  return (
    <TransactionOverviewDetailsItem label={label}>
      <div className="flex flex-row items-center gap-2">
        <TokenValue token={token} value={currentValue} /> <ArrowRightIcon className="h-5 w-5 text-muted-foreground" />
        <TokenValue token={token} value={updatedValue} />
      </div>
    </TransactionOverviewDetailsItem>
  )
}

function TokenValue({
  value,
  token,
}: {
  value: NormalizedUnitNumber
  token: Token
}) {
  const chainId = useChainId()
  const formattedValue = token.format(value, { style: 'auto' })
  const displayToken = getDisplayToken(chainId, token)
  return (
    <span className="text-center">
      {formattedValue} {displayToken.symbol}
    </span>
  )
}
